import { Component, ChangeDetectionStrategy } from '@angular/core'

import { MatIcon } from '@angular/material/icon'
import { MatDialogRef } from '@angular/material/dialog'

import { ButtonComponent } from '../../../../../components/button/button.component'

@Component({
  selector: 'app-amazon-connect-disconnect-warning',
  standalone: true,
  imports: [MatIcon, ButtonComponent],
  templateUrl: './amazon-connect-disconnect-warning.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./amazon-connect-disconnect-warning.component.scss'],
})
export class AmazonConnectDisconnectWarningComponent {
  constructor(
    private dialogRef: MatDialogRef<
      AmazonConnectDisconnectWarningComponent,
      'disconnect'
    >,
  ) {}

  cancel(): void {
    this.close()
  }

  disconnect(): void {
    this.dialogRef.close('disconnect')
  }

  close(): void {
    this.dialogRef.close()
  }
}
